import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { meQuery, type Me } from '@/lib/authQuery';

/** Layout guard for everything under /host — requires a host session (02 §7). */
export const Route = createFileRoute('/host')({
  beforeLoad: async ({ context }): Promise<{ me: Me }> => {
    const me = await context.queryClient.ensureQueryData(meQuery);
    if (!me) {
      throw redirect({ to: '/singnow' });
    }
    return { me };
  },
  component: () => <Outlet />,
});
